<template >
  <CSidebar 
  class="fiz" style="overflow-y: scroll;"
    fixed 
    :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand  to="/">
      <CIcon 
        class="c-sidebar-brand-full mb-2 mt-1 fix1" 
        name="logo" 
        size="custom-size"         
        :width="255" 
        viewBox="0 0 456 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="55" 
        viewBox="0 0 210 334"
      />
    </CSidebarBrand>

   
          <CContainer class="sideList">
            <!-- <div>
              <label for="">Layout:</label>
              <i class="fa fa-th-list ml-2 mr-2" aria-hidden="true"></i>
              <i class="fa fa-th-large mr-2" aria-hidden="true"></i>
              <i class="fa fa-table mr-2" aria-hidden="true"></i>
            </div>
            <div class=""> -->
              <!-- <i class="cil-chevron-double-down"></i> -->

              <!-- <CSelect
                          label="CNH"
                          horizontal
                          :options="['Sem preferência',
        'A',        
        'B',
        'C',
        'D',
        'E',
        'AB',
        'AC',
        'AD',
        'AE']"
                          class=""
                          
                        /> 
              
            </div> -->
            <!-- <i class="cil-chevron-double-down"></i> -->

           <!--  <div class="form-check form-check-inline">
                            <CInputCheckbox                                  
                              class="form-check-input"
                              custom                                
                              true-value="Sim"
                              false-value="Não" />
                            <label class="form-check-label">Selecionar todos</label>
                          </div> -->

            

            <div class="sideLi">
               <CSelect
                          label="Experiência"
                          horizontal
                          :options="['Sim', 'Não', 'Indiferente']"
                          value="Indiferente"
                          class="Li-info"
                        />
            </div>

            <div class="sideLi">
               <CSelect
                          label="Cargo"
                          horizontal
                          :options="['Estágio', 'Efetivo', 'Indiferente']"
                          value="Indiferente"
                          class="Li-info"
                        />
            </div>
            
            <div class="sideLi">
               <CSelect
                          label="Sexo"
                          horizontal
                          :options="['Masculino', 'Feminino', 'Outro', 'Indiferente']"
                          value="Indiferente"
                          class="Li-info"
                        />
            </div>
            
            
            
            <div class="sideLi">
              <CInput
                          label="Data de cadastro"
                          type="date"
                          horizontal
                          description="Início."
                          v-mask="'##/##/####'" 
                        />
            </div>
            <div class="sideLi">
              <CInput                          
                          type="date"
                          horizontal
                          description="Fim."                          
                        />
            </div>

                        <template>
                          <CRow form class="form-group">
                            <CCol sm="3">
                              PcD*
                            </CCol>
                            <CInputRadioGroup
                              class="col-sm-9"
                              :options="['Sim', 'Não']"
                              custom
                              checked="Não"
                              inline
                            />
                          </CRow>
                        </template>

                        <template>
                          <CRow form class="form-group">
                            <CCol sm="3">
                              PcD*
                            </CCol>
                            <CInputRadioGroup
                              class="col-sm-9"
                              :options="['Sim', 'Não']"
                              custom
                              checked="Não"
                              inline
                            />
                          </CRow>
                        </template>

                        <template>
                          <CRow form class="form-group">
                            <CCol sm="3">
                              PcD*
                            </CCol>
                            <CInputRadioGroup
                              class="col-sm-9"
                              :options="['Sim', 'Não']"
                              custom
                              checked="Não"
                              inline
                            />
                          </CRow>
                        </template>

            <!-- <div class="sideLi">
              <div class="Li-title">Location</div>
              <div class="Li-info">
                <select>
                  <option value="Taiwan">Taiwan</option>
                </select>
              </div>
            </div> -->
            <!-- <div class="sideLi">
              <div class="Li-title">Date</div>
              <div class="Li-info">
                <p class="dateForm">
                  <label for="from">from</label>
                  <input type="text" id="from">
                </p>
                <p class="dateForm">
                  <label for="from">to</label>
                  <input type="text" id="to">      
                </p>
              </div>
            </div>
            <div class="sideLi">
              <div class="Li-title">Categories</div>
              <div class="Li-info">
                <ul>
                  <li>
                    <input type="checkbox" value="All" id="all">
                    <label for="all">All</label>
                  </li>
                  <li>
                    <input type="checkbox" value="Entertainment" id="Entertainment">
                    <label for="Entertainment">Entertainment</label>
                  </li>
                  <li>
                    <input type="checkbox" value="Food" id="Food">
                    <label for="Food">Food</label>
                  </li>
                  <li>
                    <input type="checkbox" value="Learning" id="Learning">
                    <label for="Learning">Learning</label>
                  </li>
                  <li>
                    <input type="checkbox" value="Outdoors" id="Outdoors">
                    <label for="Outdoors">Outdoors</label>
                  </li>              
                </ul>
              </div>
            </div> -->
          </CContainer>
        

    <!-- <CRenderFunction class="fix" flat /> -->
     
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarShow', false])"
    />
  </CSidebar>
</template>

<script>
import nav from './A_nav'

export default {
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>

<style lang="scss" scoped>
.fa-th-list:before,
.fa-table:before,
.fa-th-large:before {
      font-size: 16px;
}
.fix {
  padding-left: 0rem;
  margin-top: 2rem;
}

.fix1 {
  margin-left: -20px;
}
.fiz {
  background-image: linear-gradient( 135deg, #2d1cc4 10%, #2d1cc4 100%);
}
.c-sidebar .c-sidebar-minimizer {
    background-color: rgba(248, 248, 255, 0.0);
}
.c-sidebar .c-sidebar-brand {
    color: #fff;
    background: rgba(0, 0, 21, 0);
}
.c-sidebar.c-sidebar-minimized .c-sidebar-nav-item > .c-sidebar-nav-link, .c-sidebar.c-sidebar-minimized .c-sidebar-nav-item:hover > .c-sidebar-nav-dropdown-toggle {
    background: #2d1cc4;
}

*{
box-sizing:border-box;
-moz-box-sizing:border-box; 
-webkit-box-sizing:border-box;
}
body{
  background: #F2F2F2;
}
.header{
  padding:24px 0;
  background: #7828B4;

}

.col-flex{
  display: flex;
}
.col-4{
  flex: 4 0 0;
}
.col-8{
  flex: 8 0 0;
}
.font-weight{
  font-weight: 900;
}
.text-right{
  text-align:right;
}
::placeholder { 
    color: #FFF;
    opacity: .5; 
}

:-ms-input-placeholder { 
    color: #FFF;
    opacity: .5; 
}

::-ms-input-placeholder {
    color: #FFF;
    opacity: .5; 
}
/****************************/

.sideList{
  margin: 20px 18px 10px 15px ;
  
 
  .Li-title{
    font-family: '微軟正黑體';
    font-size: 20px;
    color: #000000;
    margin-bottom: 15px;
    font-weight: 900;
  }
  select{
    font-size: 20px;
    color: #000000;
    width:100%;
    padding: 6px 0 6px 5px;
    border:0;
    outline:0;
  }
  .dateForm{
    margin-bottom:5px;
    label{
      width: 35px;
      display: inline-block;
      text-align: right;
      padding-right: 5px;
    }
    input{
      width:130px;
      font-size: 20px;
      border:0;
      outline:0;
      padding:5px 8px;
    }
  }
}
.results{
  margin:24px 0 8px;
  font-size: 24px;
  font-weight: blod;
}
.tagList{
  display:flex;
  margin-bottom: 24px;
  .unitag{
     border: 1px solid #9013FE;
     border-radius: 100px;
     padding: 8px 16px;
     color: #9013FE;
     margin-right:10px;
  }
}
.bgimg{
 background: url(https://picsum.photos/200/300/?random) no-repeat center center;
 background-size: cover;
  
}
.mainlist{
  .col-flex{
    margin-bottom: 25px;
  }
}
.listiem{
  padding: 20px;
  background:#FFF;
  .item-title{
    color:#9013FE;
    font-size: 18px;
    margin-bottom: 16px;
  }
  .item-descrition{
    height: 30px;    
    margin-bottom: 16px;
  }
  .item-info{
    margin-bottom:10px;
    .tag{
      display:inline-block;
      padding:3px 8px;
      background: #D7D7D7;
      border-radius: 100px;
      color:#FFF;
    }
  }
  .item-other{
    span{
      display:inline-block;
      margin-right:10px;
      color: #9B9B9B;
    }
  }
}

.pager{
  display:inline-block;
  li{
    float:left;
    width:30px;
    height:30px;
    text-align:center;
    line-height: 30px;
    background-color: #fff;
    border:1px solid #ccc;
    color:#9B9B9B;
  }
}

.form-row {
  display: block;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background-color: #dfdfdf;
  border-radius: 10px;
}
</style>
